import { $admin } from "./api/admin";
import apiEndpoints from "@/constants/api-endpoints";

/**
 * Create mailbox provider
 * @param {Object} payload Details of mailbox provider to be created
 * @returns {Promise} Details of newly created mailbox provider record
 */
export const createMailboxProvider = (payload) => {
  return $admin.post(apiEndpoints.mailboxProviders, payload);
};

/**
 * Updates mailbox provider
 * @returns {Promise} Containing updated mailbox provider
 */
export const updateMailboxProvider = ({ id, ...payload }) => {
  return $admin.put(`${apiEndpoints.mailboxProviders}/${id}`, payload);
};

/**
 * Delete mailbox provider
 * @param {Stsring | Number} id Id of the mailbox provider to be deleted
 * @returns {Promise} Containg details of deleted mailbox provider
 */
export const deleteMailboxProvider = (id) => {
  return $admin.delete(`${apiEndpoints.mailboxProviders}/${id}`);
};

/**
 * Fetches list mailbox providers
 * @param {Object} params - Api request params
 * @returns {Promise} Api response list of mailbox providers
 */
export const getMailboxProviders = (params) => {
  return $admin.get(apiEndpoints.mailboxProviders, { params });
};

/**
 * Fetches details of a mailbox provider
 * @param {Object} id - id of mailbox provider
 * @param {Object} params - Api request params
 * @returns {Promise} Api response containing details of a mailbox provider
 */
export const getMailboxProvider = (id, params) => {
  return $admin.get(`${apiEndpoints.mailboxProviders}/${id}`, { params });
};
